export default __webpack_public_path__ + "static/media/helpAddGoods.b5b8e623.png";